import { d as t, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as n, normalizeClass as r, normalizeStyle as l, createElementVNode as c } from "vue";
const a = t("github"), i = /* @__PURE__ */ c("path", {
  d: "M512 12.672c-282.88 0-512 229.248-512 512 0 226.261 146.688 418.133 350.08 485.76 25.6 4.821 34.987-11.008 34.987-24.619 0-12.16-.427-44.373-.64-87.04-142.422 30.891-172.459-68.693-172.459-68.693-23.296-59.093-56.96-74.88-56.96-74.88-46.379-31.744 3.584-31.104 3.584-31.104 51.413 3.584 78.421 52.736 78.421 52.736 45.654 78.293 119.851 55.68 149.12 42.581 4.608-33.109 17.792-55.68 32.427-68.48-113.707-12.8-233.216-56.832-233.216-253.013 0-55.893 19.84-101.547 52.693-137.387-5.76-12.928-23.04-64.981 4.48-135.509 0 0 42.88-13.739 140.8 52.48 40.96-11.392 84.48-17.024 128-17.28 43.52.256 87.04 5.888 128 17.28 97.28-66.219 140.16-52.48 140.16-52.48 27.52 70.528 10.24 122.581 5.12 135.51 32.64 35.84 52.48 81.493 52.48 137.386 0 196.693-119.68 240-233.6 252.587 17.92 15.36 34.56 46.762 34.56 94.72 0 68.522-.64 123.562-.64 140.202 0 13.44 8.96 29.44 35.2 24.32C877.44 942.592 1024 750.592 1024 524.672c0-282.752-229.248-512-512-512",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, u, h) {
  return s(), n("svg", {
    class: r(e.classes),
    style: l(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const v = /* @__PURE__ */ o(a, [["render", m]]);
export {
  v as default
};
